import React from 'react';
import { PoweroffOutlined, SettingOutlined } from '@ant-design/icons';
import { Dropdown, Menu, Avatar, Modal } from 'antd';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import * as actionCreators from '../store/actions/index';

const AppHeader = (props) => {
  const navigate = useNavigate();

  // Define the profile dropdown menu using Ant Design's Menu component
  const profileMenu = (
    <Menu>
      <Menu.Item disabled key="profileManage" icon={<SettingOutlined />}>
        Profile Setting
      </Menu.Item>
      <Menu.Item
        key="logout"
        icon={<PoweroffOutlined />}
        onClick={() =>
          Modal.confirm({
            title: 'Log Out',
            content: (
              <div>
                <p>Are you sure you would like to log out?</p>
              </div>
            ),
            onOk() {
              props.onLogout(navigate);
            },
          })
        }
      >
        Logout
      </Menu.Item>
    </Menu>
  );

  return (
    <header className="sticky top-0 z-50 flex items-center justify-end bg-white p-4 pr-8 shadow-sm">
      <Dropdown overlay={profileMenu} trigger={['click']}>
        <div className="flex cursor-pointer items-center">
          <Avatar src="/images/user.jpg" size="large" />
          <span className="ml-2 font-medium text-gray-700">
            Dr. {localStorage.getItem('userFullName')}
          </span>
        </div>
      </Dropdown>
    </header>
  );
};

const mapStateToProps = (state) => ({
  loading: state.login.loading,
});

const mapDispatchToProps = (dispatch) => ({
  onLogout: (navigate) => dispatch(actionCreators.logout(navigate)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AppHeader);
